import Basic from "./BasicComponent";
export default Basic;
